import React from 'react';
import PropTypes from 'prop-types';

import Pic1 from '../../InstallImages/Inverters/Enphase_IQ7';


const enphaseLink1 = <a href="https://enphase.com/en-us/products-and-services/microinverters/quality-solar-inverter" rel="noopener noreferrer" target="_blank">Enphase Microinverters: It&#39;s all about quality</a>;

const enphaseLink2 = <a href="https://enphase.com/en-us/products-and-services/microinverters/vs-string-inverter" rel="noopener noreferrer" target="_blank">Microinverters vs. String Inverters: What&#39;s the difference?</a>;

const Inverter = ({ resiToggle }) => (
    <div>
        <div className="col span-1-of-2">
            <Pic1 />
        </div>
        <div className="col span-1-of-2">

            <p className="specsText">Be it residential or commercial rooftop, carport or, ground mount installation, Enphase microinverters offer optimum energy harvest when compared with other inverter-based systems. With comprehensive module-level monitoring and robust quality, Enphase systems are reliable even in adverse environmental conditions. A smart choice for commercial-scale PV installations.
            </p>
            <p className="specsText">Solar panels may get all the glory, but it&#39;s the inverter that does all the work in a solar energy system. Tucked beneath each solar panel, microinverters convert the direct current (DC) power collected from the solar panels to alternating current (AC), the form of electricity your home can use.
            </p>
            <ul>
                <li className="specsText">{enphaseLink1}</li>
                <li className="specsText">{enphaseLink2}</li>
            </ul>
            {resiToggle ?
                <div>
                    <p>
                        <a href="https://enphase.com/en-us/homeowners-storage-solutions?wvideo=589q1781cz" target="_blank" rel="noopener noreferrer"><img src="https://embedwistia-a.akamaihd.net/deliveries/2e901be91043870dae01c0e4726521cc74bea2d6.jpg?image_play_button_size=2x&amp;image_crop_resized=960x540&amp;image_play_button=1&amp;image_play_button_color=f37321e0" alt="" width="400" height="225" style={{ width: '400px', height: '225px' }} />
                        </a>
                    </p>
                    <p><a href="https://enphase.com/en-us/homeowners-storage-solutions?wvideo=589q1781cz">Visit Homeowners Storage Solutions | Enphase</a></p>
                </div>
                :
                null
            }
        </div>
    </div>
);

Inverter.propTypes = {
    resiToggle: PropTypes.string.isRequired,
};

export default Inverter;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/SystemSpecs/Inverters/enphase.js